import {EventEmitter, Injectable} from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class ImpuestosService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }


  obtenerImpuestos(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        {
          impuesto {
            obtenerTodos {
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                  es_adicional
                  es_retenido
                  es_porcentaje
                  valor
                  factor
                  fecha_registro
                }
              }
            }
          }
        }
        `,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.impuesto.obtenerTodos
        callback({ mensajes, respuesta })
      }
    );
  }


}
